import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Footer from "./components/footer/Footer";
import Navigation from "./components/navigation/Navigation";
import RouteConstants from "./constants/RouteConstants";
import FAQ from "./containers/FAQ";
import Home from "./containers/Home";
import HologramDetails from "./containers/HologramDetails";
import theme from "./theme/theme";
import { Box, styled, ThemeProvider } from "@mui/material";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const Root = styled(Box)({});

const Nav = styled(Box)({});

const Body = styled(Box)({});

const StyledFooter = styled(Box)({});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_CLIENT_ID} useEnterprise>
        <BrowserRouter>
          <Root>
            <Nav>
              <Navigation />
            </Nav>
            <Body>
              <React.Suspense fallback={<div />}>
                <Switch>
                  <Route path={RouteConstants.BASE} exact component={Home} />
                  <Route path={RouteConstants.FAQ} exact component={FAQ} />
                  <Route path={RouteConstants.DETAILS} exact component={HologramDetails} />
                </Switch>
              </React.Suspense>
            </Body>
            <StyledFooter>
              <Footer />
            </StyledFooter>
          </Root>
        </BrowserRouter>
      </GoogleReCaptchaProvider>
    </ThemeProvider>
  );
};

export default App;
